import React from 'react';
import { Card, Form, Select, Switch, Button, Row, Col, Space } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import { TermsAndConditionsFilter, TermsAndConditionsType } from '../types';

interface TermsAndConditionsFilterProps {
  onFilter: (filter: TermsAndConditionsFilter) => void;
  loading?: boolean;
}

export const TermsAndConditionsFilterComponent: React.FC<TermsAndConditionsFilterProps> = ({
  onFilter,
  loading = false,
}) => {
  const [form] = Form.useForm<TermsAndConditionsFilter>();

  const handleFilter = () => {
    const values = form.getFieldsValue();
    onFilter(values);
  };

  const handleReset = () => {
    form.resetFields();
    onFilter({});
  };

  return (
    <Card title="Filter" size="small" className="mb-4">
      <Form form={form} layout="vertical" onFinish={handleFilter}>
        <Row gutter={16}>
          <Col xs={24} md={8}>
            <Form.Item name="type" label="Type">
              <Select 
                placeholder="Select a type" 
                allowClear
                options={Object.values(TermsAndConditionsType).map(type => ({
                  value: type,
                  label: type.replace(/_/g, ' ')
                }))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="entityId" label="Entity ID">
              <Select allowClear placeholder="Select entity ID" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item 
              name="showActive" 
              label="Show active only" 
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="flex justify-end">
              <Space>
                <Button 
                  icon={<ClearOutlined />} 
                  onClick={handleReset}
                >
                  Reset
                </Button>
                <Button 
                  type="primary" 
                  icon={<SearchOutlined />} 
                  loading={loading} 
                  htmlType="submit"
                >
                  Filter
                </Button>
              </Space>
            </div>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
